/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Choice, Statement } from '@/customTypes/chatStory';
import FullImageContainer from '../../../../storyCommon/FullImageContainer';
import UserChoiceText from '@/components/storyCommon/UserChoiceText';

const ChoiceInputImageItem = ({ statement }: { statement: Statement }) => {
  const choice = statement as Choice;

  const [imageWidth, setImageWidth] = useState<number>(0);
  const [imageHeight, setImageHeight] = useState<number>(0);

  if (!choice.options) {
    return null;
  }

  const setImageSize = (width: number, height: number) => {
    setImageWidth(width);
    setImageHeight(height);
  };

  return (
    <FullImageContainer
      imageWidth={choice?.options?.choiceBackgroundImage?.width}
      imageHeight={choice?.options?.choiceBackgroundImage?.height}
      imageURL={choice?.options?.choiceBackgroundImage?.imageUrl}
      setImageSize={setImageSize}
      hasTopMargin={true}
    >
      <UserChoiceText
        options={choice?.options}
        imageSize={{ width: imageWidth, height: imageHeight }}
        rightUserInputText={statement?.rightUserInputText}
      />
    </FullImageContainer>
  );
};

export default ChoiceInputImageItem;
